<template>
    <a-modal
      class="ant-modal-custom"
      :width="'600px'"
      :visible="visible"
      :confirmLoading="loading"
      :footer="null"
      @cancel="handleEditCancel"
      >
      <div class="title">
        自定义量表
      </div>
      <br/>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :loading="loading"
        :dataSource="dataSource"
        :pagination="false">
      <span slot="action" slot-scope="text, record">
        <a @click="handleDelete(record.id)"><a-icon type="scissor"/>删除</a>
      </span>
      </a-table>
    </a-modal>
</template>

<script>
import { deleteAction, getAction } from '@api/manage'
  export default {
    name: 'ModuleFormDiyList',
    props:{
      project:{
        type:Object,
        default:()=>{
          return { }
        }
      },
      diseaseCode:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        columns:[
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '表单名称',
            align: "left",
            dataIndex: 'formName'
          },
          {
            title: '模块名称',
            align: "left",
            dataIndex: 'moduleName'
          },
          {
            title: '文件名称',
            align: "left",
            dataIndex: 'fileName'
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 60,
            align: "center",
            scopedSlots: {customRender: 'action'}
          }
        ],
        visible:false,
        dataSource:[],
        loading:false,
      }
    },
    computed: {

    },
    mounted(){

    },
    methods:{

      handleEditCancel(){
        this.visible = false
      },
      open(){
        this.visible = true
        this.loadData()
      },
      loadData(){
        this.loading = true
        getAction('/projectconfigview/formFile/listAll',{projectId:this.project.id,diseaseCode:this.diseaseCode}).then(res=>{
          if(res.success){
            this.dataSource = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleDelete(id){
        this.$confirm({
          title: '删除自定义量表',
          content: (<div>
            <p>您确定要彻底删除自定义量表吗？</p>
          </div>),
          centered: false,
          onOk: () => {
            this.loading = true
            deleteAction('/projectconfigview/formFile/delete',{id:id}).then(res=>{
              if(res.success){
                this.loadData()
              }
            }).finally(()=>{
              this.loading = false
            })
          },
        })

      },
    }
  }
</script>

<style scoped lang="less">
  .ant-modal-custom {
    /deep/ .ant-modal-content{
      background: linear-gradient(to bottom, #191f35, #252628);
    }
    /deep/ .ant-table-placeholder{
      background: transparent;
    }
    /deep/ th{
      color: white;
      background: transparent;
    }
    /deep/ td{
      color: white;
      background: transparent;
    }
    /deep/ .ant-empty-description{
      color: white;
    }
    /deep/ .ant-modal-close{
      color: white;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 21px;
  }

</style>